// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Cookies from 'js-cookie'
import VCharts from 'v-charts'

// v-charts 1.x in Vue 2.7 can read this._watchers too early.
Vue.mixin({
  beforeCreate() {
    if (!Array.isArray(this._watchers)) {
      this._watchers = []
    }
  }
})

Vue.use(VCharts)
Vue.use(ElementUI, { size: 'small' })
Vue.config.productionTip = false

Vue.config.errorHandler = (err, vm, info) => {
  if (err && (err.isNetworkError || err.code === 'NETWORK_ERROR' || err.message === 'Network Error')) {
    console.warn('网络错误已捕获', err.message)
    return
  }
  console.error('Vue 错误:', err, info)
}

if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (event) => {
    const error = event.reason
    const errorMessage = error?.message || error?.toString() || ''
    const errorName = error?.name || ''

    if (error && (
      error.isNetworkError ||
      error.code === 'NETWORK_ERROR' ||
      errorMessage.includes('Network Error') ||
      errorMessage.includes('ERR_NETWORK') ||
      errorName === 'AxiosError' ||
      errorMessage.includes('axios') ||
      (error.originalError && error.originalError.message && error.originalError.message.includes('Network Error'))
    )) {
      console.warn('未处理的网络错误已捕获', errorMessage || errorName)
      event.preventDefault()
      return
    }
    console.error('未处理的 Promise 拒绝:', event.reason)
  })

  window.addEventListener('error', (event) => {
    const error = event.error
    const errorMessage = error?.message || event.message || ''

    if (error && (
      error.isNetworkError ||
      error.code === 'NETWORK_ERROR' ||
      errorMessage.includes('Network Error') ||
      errorMessage.includes('ERR_NETWORK') ||
      error.name === 'AxiosError' ||
      errorMessage.includes('axios')
    )) {
      console.warn('运行时网络错误已捕获:', errorMessage)
      event.preventDefault()
    }
  })
}

function isMobilePath() {
  return typeof window !== 'undefined' && window.location.pathname.startsWith('/mobile')
}

async function bootstrapDesktop() {
  const [{ default: App }, { default: router }, { default: store }, { default: api }] = await Promise.all([
    import('./App'),
    import('./router'),
    import('./store'),
    import('./api')
  ])

  Vue.prototype.$api = api
  Vue.prototype.Cookies = Cookies

  router.beforeEach((to, from, next) => {
    next()
  })

  new Vue({
    el: '#app',
    router,
    store,
    render: (h) => h(App)
  }).$mount('#app')
}

async function bootstrapMobileFromDesktopEntry() {
  const [{ default: MobileApp }, { default: mobileRouter }, { default: mobileStore }, { default: mobileApi }] = await Promise.all([
    import('./mobile/App.vue'),
    import('./mobile/router'),
    import('./mobile/store'),
    import('./mobile/api')
  ])
  await import('./mobile/styles/base.scss')

  Vue.prototype.$api = mobileApi
  Vue.prototype.Cookies = Cookies

  new Vue({
    router: mobileRouter,
    store: mobileStore,
    render: (h) => h(MobileApp)
  }).$mount('#app')
}

if (isMobilePath()) {
  bootstrapMobileFromDesktopEntry()
} else {
  bootstrapDesktop()
}
